module.exports = __webpack_public_path__ + "assets/img/office-marker-opened.95d82039.svg";